import type { ClientConfig } from './types'
import { clientLoaders } from '@/config/registry'
import { resolveClientId } from './clientResolver'

/**
 * Resolves the active client ID and dynamically imports its config module.
 * Only the chosen client's bundle is loaded — other clients stay in their own chunks.
 *
 * If the resolved client id has no loader (shouldn't happen because resolveClientId
 * already filters against the known list), we fall back to AccuWeather.
 */
export async function loadClientConfig(): Promise<ClientConfig> {
  const clientId = resolveClientId()
  const loader = clientLoaders[clientId] ?? clientLoaders.accuweather
  return loader()
}
